export default "__VITE_ASSET__1a28b2ac__"